import {Component, DestroyRef, EventEmitter, inject, Input, OnInit, Output} from '@angular/core';
import {IFunctionsDto, IMemberFirmGuestRequest} from '@employee-models/data.models';
import {VISA_TYPE} from '@employee-pages/shared/components/fields-for-forms/visa-type/visa-type.model';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {UsersService} from '../../../../core/services/data-access/users.service';
import {BaseComponent} from '@ui-app/components/base.component';

export interface IMemberFirmGuestRequestValid extends IMemberFirmGuestRequest {
    isValid?: boolean;
    errors?: string[];
}

@Component({
    selector: 'employee-guest-grid',
    templateUrl: './guest-grid.component.html',
    styleUrls: ['./guest-grid.component.less']
})
export class GuestGridComponent extends BaseComponent implements OnInit {
    @Input() guestsData: IMemberFirmGuestRequestValid[];
    @Input() showAddGuestButton: boolean;
    @Output() newGuestForm = new EventEmitter<boolean>();
    @Output() deleteGuestData = new EventEmitter<string>();
    @Output() editGuestData = new EventEmitter<IMemberFirmGuestRequestValid[]>();
    @Input() isBadgeExtension: boolean = false;
    guestToEdit: IMemberFirmGuestRequest;
    guestIndex: number;
    isEdit = false;
    protected destroyRef = inject(DestroyRef);

    visaTypes = VISA_TYPE;

    defaultImageUrl = '../../assets/img/badge-requests/no-photo.svg';
    businessFunctions: IFunctionsDto[];

    constructor(private usersService: UsersService) {
        super();
    }

    ngOnInit(): void {
        this.usersService.getFunctions()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(data => {
                this.businessFunctions = data;
            });
    }

    addNewGuest(isBadgeExtension: boolean = false): void {
    if (!this.guestToEdit) {
        const guestPayload: any = {};
        guestPayload.isBadgeExtension = isBadgeExtension;
        this.newGuestForm.emit(guestPayload);
    }
}

    deleteGuest(guest: IMemberFirmGuestRequest): void {
        if (!this.guestToEdit && this.showAddGuestButton) {
            this.deleteGuestData.emit(guest.emailAddress);
        }
    }

    cancel(isCancel: boolean): void {
        this.guestToEdit = null;
        this.isEdit = false;
        this.guestIndex = null;
    }

    editGuest(updatedGuest: IMemberFirmGuestRequest): void {
        const originalGuest = this.guestsData[this.guestIndex];
        this.guestsData = this.guestsData.filter((item, index) => index !== this.guestIndex);
        this.guestsData = [
            ...this.guestsData.slice(0, this.guestIndex),
            { 
                ...updatedGuest, 
                isValid: true,
                // Preserve isBadgeExtension flag from original guest
                isBadgeExtension: (originalGuest as any).isBadgeExtension || (updatedGuest as any).isBadgeExtension
            } as any,
            ...this.guestsData.slice(this.guestIndex)
        ] as any;
        this.editGuestData.emit(this.guestsData);
        this.cancel(true);
    }

    openEditGuest(guest: IMemberFirmGuestRequest, guestIndex: number): void {
        if (!this.guestToEdit && this.showAddGuestButton) {
            this.guestToEdit = guest;
            this.isEdit = true;
            this.guestIndex = guestIndex;
        }
    }

}
